import { atom } from 'nanostores';
export const $isTributeButtonHovered = atom(false);
